import React, { useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import EditorJS from '@editorjs/editorjs';

import ImageInstructionModal from './ImageInstructionModal';
import { addInstructionEventByEditor } from '../utils';
import { InstructionEvent } from '../types';
import {
  setImageInstructionId,
  setOpenImageInstructionModal,
  setInlineImageInstruction,
} from '../../../../store/modules/script-editor/actions';
import { selectImageInstruction } from '../../../../store/modules/script-editor/selectors';
import { addEventListenerToImageActions } from './utils';
import {Formik} from "formik";

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const ImageInstructionComponent = ({ instanceEditor, refEditor }: Props) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector(selectImageInstruction);

  useEffect(() => {
    if (instanceEditor) {
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_IMAGE_INSTRUCTION_MODAL,
        (data) => {
          dispatch(setOpenImageInstructionModal(true));
          dispatch(setImageInstructionId(data.instructionId));
          dispatch(setInlineImageInstruction(data.isInline));
        },
      );
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.UPDATE_IMAGE_ACTION_EVENT_LISTENERS,
        // eslint-disable-next-line
        ({ refEditor, instanceEditor }) => {
          addEventListenerToImageActions({ instanceEditor, refEditor });
        },
      );
    }
  }, [dispatch, instanceEditor]);

  useEffect(() => {
    if (instanceEditor && refEditor) {
      addEventListenerToImageActions({ instanceEditor, refEditor });
    }
  }, [instanceEditor, refEditor]);

  if (!isOpenModal) {
    return null;
  }

  return (
    <Formik initialValues={{image: ''}} onSubmit={()=>{}}>
      <ImageInstructionModal instanceEditor={instanceEditor} />
    </Formik>
  );
};

export default ImageInstructionComponent;
